define.alias("shared/utils/object-methods/object-snake-to-camel", "calendar/utils/object-methods/object-snake-to-camel");